<div data-testid="entries-table-container" class="table-container">
  @if(facilitiesCount() > 0) {
  <div data-testid="pagination-container" class="pagination-container">
    <div class="per-page-selector" data-testid="per-page-selector" mb="m">
      <span>Show</span>
      <goab-dropdown
        data-testid="per-page-dropdown"
        (onChange)="handlePerPageCountChangeEvent($event)"
        [value]="perPageCount()"
        maxHeight="500px"
        width="9ch"
      >
        <goab-dropdown-item
          *ngFor="let option of perPageCountOptions()"
          [value]="option.toString()"
          [label]="option.toString()"
        ></goab-dropdown-item>
      </goab-dropdown>

      <span data-testid="total-entries-count" class="entries-count"
        >of {{ facilitiesCount() }}</span
      >
    </div>

    <goab-pagination
      class="pagination-selector"
      data-testid="pagination-selector"
      [itemCount]="facilitiesCount()"
      [perPageCount]="perPageCount()"
      [pageNumber]="page()"
      (onChange)="handlePageChange($event)"
    ></goab-pagination>
  </div>
  }
</div>
